<template>
  <el-row>
    <el-col :span="24" class="text-center">
      <h1>Coming soon!</h1>
    </el-col>
  </el-row>
</template>

<script>
  export default {
    name: 'ComingSoon',
  };
</script>
